import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UtilService } from '../../../services/util.service';
import { API, CullDTO, PlayerCullDTO } from '../../../services/api/api';
import { ModalService } from '../../../services/gui/modal/modal.service';
import { SbDateTime } from '../../../services/api/api-date-time';
import { TranslateService } from '@ngx-translate/core';
import { DateTime, Duration } from 'luxon';
import { ErrorService } from '../../../services/error.service';
import { MsOptions } from '../../../services/global/global-interfaces';
import { PermissionService } from '../../../services/permission.service';

@Component({
  selector: 'sb-comp-chart-control',
  templateUrl: './sb-chart-control.component.html',
  styleUrls: ['./sb-chart-control.component.scss'],
  standalone: false,
})
export class SbChartControlComponent implements OnInit {
  @Input() from: SbDateTime;
  @Input() till: SbDateTime;
  @Input() filteredPlayerCulls: PlayerCullDTO[];
  @Input() showPlayerCull: boolean = true;
  @Input() interval = 86400;
  @Input() enableHourInterval = false;
  @Input() hideInterval: boolean = false;
  @Output() intervalChange: EventEmitter<number> = new EventEmitter<number>();

  @Output() dateChange: EventEmitter<{ fromDate: SbDateTime; toDate: SbDateTime; interval: number }> = new EventEmitter<{
    fromDate: SbDateTime;
    toDate: SbDateTime;
    interval: number;
  }>();

  @Output() filterChange: EventEmitter<PlayerCullDTO[]> = new EventEmitter<PlayerCullDTO[]>();

  timespan: Duration;
  intervalSettings: { interval: number; name: string }[];

  culls: CullDTO[];
  msCullOptions: MsOptions;

  constructor(
    public util: UtilService,
    private modalService: ModalService,
    private translate: TranslateService,
    private api: API,
    private errorHandler: ErrorService,
    public permissionService: PermissionService
  ) {
    this.filteredPlayerCulls = [];
    this.culls = [];
    this.timespan = Duration.fromMillis(0);
    this.intervalSettings = [];
  }

  ngOnInit(): void {
    this.generateIntervalSettings();
    this.translate.onDefaultLangChange.subscribe(() => {
      this.generateIntervalSettings();
    });
    this.updateTimespan();
  }

  generateIntervalSettings() {
    const month = this.translate.instant('lang.globals.month');
    const week = this.translate.instant('lang.globals.week');
    const day = this.translate.instant('lang.globals.day');
    const hour = this.translate.instant('lang.globals.hour');
    this.intervalSettings = [
      {
        interval: 2629746,
        name: month,
      },
      {
        interval: 604800,
        name: week,
      },
      {
        interval: 86400,
        name: day,
      },
    ];
    if (this.enableHourInterval) {
      this.intervalSettings.push({
        interval: 3600,
        name: hour,
      });
    }
  }

  updateTimespan() {
    if (this.from && this.till) {
      this.timespan = DateTime.fromJSDate(this.util.localDateToJSDate(this.till)).diff(
        DateTime.fromJSDate(this.util.localDateToJSDate(this.from)),
        'days'
      );
    }
  }

  handleDateChange(dates) {
    this.dateChange.emit({ fromDate: dates.fromDate, toDate: dates.toDate, interval: this.interval });
    this.updateTimespan();
  }

  setInterval(interval: number) {
    this.interval = interval;
    this.intervalChange.emit(this.interval);
  }

  update($event, type: string) {
    switch (type) {
      case 'PLAYER_CULLS':
        if ($event && $event?.length > 0) {
          this.filteredPlayerCulls = $event;
        } else {
          this.filteredPlayerCulls = [];
        }
        this.filterChange.emit(this.filteredPlayerCulls);
        break;
    }
  }

  msRequest(type: string, options?: MsOptions) {
    switch (type) {
      case 'PLAYER_CULLS':
        if (options) {
          this.msCullOptions = options;
        }
        if (this.msCullOptions && this.msCullOptions.pagination) {
          this.api
            .cs_Cull_retrieveAll(
              {
                search: this.util.encodeSearchQueryParam(false, this.msCullOptions.search),
                type: 'PlayerCull',
              },
              this.msCullOptions.pagination
            )
            .subscribe(
              (culls: CullDTO[]) => {
                this.culls = culls;
              },
              error => {
                this.errorHandler.errorHandler(error);
              }
            );
        }
        break;
    }
  }
}
